import type { AppIconDefinition } from "src/components/common/Icon";

import SetPageBreadcrumbs from "./SetPageBreadcrumbs";

/**
 * Defines the inputs accepted by this layout component.
 */
interface ISetIdentityBreadcrumbProps {
    owner: string;
    code: string;
    label?: string;
    href?: string;
    icon: AppIconDefinition;
    order: number;
    loading?: boolean;
}

/**
 * Registers one identity breadcrumb through the shared owner-scoped lifecycle adapter.
 */
const SetIdentityBreadcrumb = ({
    owner,
    code,
    label,
    href,
    icon,
    order,
    loading
}: ISetIdentityBreadcrumbProps) => (
    <SetPageBreadcrumbs
        owner={owner}
        breadcrumbs={[{ code, label, href, icon, order, loading }]}
    />
);

export default SetIdentityBreadcrumb;
